import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './MobileNavigationBar.scss';
import classnames from 'classnames';
import MobileNavigationNode from './MobileNavigationNode';
import {ADMIN_LINKS, PATIENT_LINKS, DOCTOR_LINKS, VMA_LINKS, GUEST_LINKS} from 'sources/constants/headerLinks';

import onClickOutside from 'react-onclickoutside';

const IGNORE_OUTSIDE_CLICK_CLASSNAME = 'ignore-react-onclickoutside';

/**
 * Aside bar content. Here we are generating links or buttons for mobile view. It also handles aside bar self-hiding.
 */
class MobileNavigationBar extends Component {
    static propTypes = {
        className: PropTypes.string,
        show: PropTypes.bool,
        role: PropTypes.object.isRequired,
        onHide: PropTypes.func.isRequired,
        onShowLogin: PropTypes.func.isRequired,
    };

    static contextTypes = {
        router: PropTypes.object
    };

    /**
     * When click outside of list -> hide it
     * @param e
     */
    handleClickOutside(e) {
        if (this.isShowed()) {
            this.props.onHide();
        }
    }

    isShowed() {
        return this.props.show;
    }

    renderNode(node, index) {
        const role = this.props.role;

        const path = node.path;
        const type = node.type || MobileNavigationNode.TYPE_LINK;
        const active = (type === MobileNavigationNode.TYPE_LINK) ? this.isActive(path, role.isGuest()) : true;

        if (role.isDoctor()) {

            if (!this.props.role.isFullAccess() && node.isNeedFullAccess) {
                return null;
            }

        } else if (role.isPatient()) {

            if (!role.isFullAccess() && node.isNeedFullAccess) {
                return null;
            }

            if (role.isFullAccess() && !node.showIfFullAccess) {
                return null;
            }

        }

        return <MobileNavigationNode key={index}
            to={(type === MobileNavigationNode.TYPE_LINK) ? path : ''}
            active={active}
            action={node.action}
            type={type}
            onClick={:: this.hide}
    label = {loc(node.label)} />;
}

getNodes() {
    let nodes;

    if (this.props.role.isGuest()) {
        nodes = GUEST_LINKS;
    } else if (this.props.role.isAdmin()) {
        nodes = ADMIN_LINKS;
    } else if (this.props.role.isDoctor()) {
        nodes = DOCTOR_LINKS;
        nodes = nodes.concat({
            type: MobileNavigationNode.TYPE_LINK,
            label: 'settings',
            path: '/settings',
            isNeedFullAccess: false,
        });
        nodes = nodes.concat({
            type: MobileNavigationNode.TYPE_LINK,
            label: 'edit-availability-label',
            path: '/availability',
            isNeedFullAccess: true,
        });
    } else if (this.props.role.isPatient()) {
        nodes = PATIENT_LINKS;
    } else if (this.props.role.isVma()) {
        nodes = VMA_LINKS;
        nodes = nodes.concat([{
            type: MobileNavigationNode.TYPE_LINK,
            label: 'settings',
            path: '/settings',
            isNeedFullAccess: false,
            showIfFullAccess: true
        }]);
    } else {
        nodes = [];
        console.error('unknown type of user.', this.props.role);
    }

    if (!this.props.role.isGuest()) {
        nodes = nodes.concat(this.getButtonsForAuthenticated());
    } else {
        nodes = nodes.concat(this.getButtonsForGuest());
    }

    return nodes;
}

getButtonsForGuest() {
    return [
        {
            label: 'login-label',
            type: MobileNavigationNode.TYPE_BUTTON,
            action: () => {
                this.props.onShowLogin();
            },
        },
        {
            label: 'sign-up-common-title',
            type: MobileNavigationNode.TYPE_BUTTON,
            action: () => {
                this.props.onShowRegistration();
            },
        }
    ];
}

getButtonsForAuthenticated() {
    return [
        {
            type: MobileNavigationNode.TYPE_BUTTON,
            label: 'logout-label',
            action: () => {
                this.hide();
                this.props.onLogout();
            },
            isNeedFullAccess: false,
            showIfFullAccess: true
        }
    ];
}

isActive = (path, checkByUrlHash = false) => {
    const hash = this.context.router.location.hash;
    const locationPath = this.context.router.location.pathname;
    return ((checkByUrlHash) ? locationPath + hash : locationPath) === path;
};

hide() {
    this.props.onHide();
}

render() {
    const {className, show} = this.props;
    const navStyles = classnames(styles.mobileNavBar,
        className ? className : '',
        show ? styles.show : styles.hide,
        IGNORE_OUTSIDE_CLICK_CLASSNAME
    );
    const nodes = this.getNodes();

    return (
        <nav className={navStyles}>
            {nodes.map(::this.renderNode)}
        </nav>
    );
}
}

export default onClickOutside(MobileNavigationBar);




// WEBPACK FOOTER //
// ./src/components/Header/Mobile/MobileNavigationBar.js